// src/config/apiKeys.js

// API keys from environment variables
export const ASSEMBLYAI_API_KEY = process.env.REACT_APP_ASSEMBLYAI_API_KEY;
export const ELEVENLABS_API_KEY = process.env.REACT_APP_ELEVENLABS_API_KEY;
export const NEBIUS_API_KEY = process.env.REACT_APP_NEBIUS_API_KEY;
